import React, { useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { ChevronDown, ChevronUp } from 'react-feather'
import PropTypes from 'prop-types'
import { Box, Button, IconButton, Switch, Typography } from '@material-ui/core'

import { MenuButton } from 'components'

import useStyles from '../../styles'

const SelectedItem = ({
  item,
  order,
  handleSwitchChange,
  handleUp,
  handleDown,
  handleOpenDialog,
  selectedItems,
  handleFieldDestroy,
  disabled,
  children,
}) => {
  const classes = useStyles()
  const [selected, setSelected] = useState(!!item?.required)

  const { control, watch } = useFormContext()

  const isEmail = item?.name === 'Email'
  const isDenyConsent = item?.name === 'Não aceitar consentimento'

  const handleSelect = (e) => {
    setSelected(e.target.checked)
    return handleSwitchChange(e, item, order)
  }

  return (
    <Box
      margin={1}
      padding={1}
      className={classes.attributeBox}
      key={item?.name}
    >
      <Box className={classes.attributeContent}>
        <Typography variant="subtitle2">{item?.name}</Typography>
        <Typography variant="caption">{item?.description}</Typography>
        <Box>
          <Controller
            control={control}
            name={item?.name}
            defaultValue={{
              subtitle: item?.description,
              required: !!item?.required,
              order,
              label: item?.label,
              placeholder: item?.placeholder,
            }}
            as={
              isDenyConsent ? (
                <Box mt={1}>
                  <Button
                    variant="contained"
                    size="small"
                    disabled={disabled}
                    className={classes.notAuthorizeButton}
                  >
                    {item?.buttonTextNotAuthorized || 'EU NÃO AUTORIZO'}
                  </Button>
                </Box>
              ) : (
                <Box display="flex" alignItems="center">
                  <Switch
                    key={item.name}
                    color="primary"
                    checked={selected ?? watch(item?.name)?.required}
                    disabled={disabled}
                  />
                  <Typography>Obrigatório</Typography>
                </Box>
              )
            }
            onChange={(event) => handleSelect(event[0])}
            mode="onChange"
          />
        </Box>
        {children}
      </Box>
      {!disabled && (
        <Box display="flex" alignItems="center" pr={1.5}>
          {isDenyConsent ? (
            <MenuButton>
              <Button
                color="secondary"
                fullWidth
                size="small"
                onClick={() => handleOpenDialog(item, true)}
              >
                Editar
              </Button>
              <Button
                color="secondary"
                fullWidth
                size="small"
                onClick={() => handleFieldDestroy(item)}
              >
                Excluir
              </Button>
            </MenuButton>
          ) : isEmail ? (
            <Box display="flex" flexDirection="column">
              <MenuButton>
                <Button
                  color="secondary"
                  fullWidth
                  size="small"
                  onClick={() => handleOpenDialog(item)}
                >
                  Editar
                </Button>
              </MenuButton>
            </Box>
          ) : (
            <>
              <Box
                width="50%"
                display="flex"
                flexDirection="column"
                justifyContent="space-evenly"
              >
                <IconButton
                  disabled={order === 1 || disabled}
                  size="small"
                  onClick={() => handleUp(order, selectedItems)}
                >
                  <ChevronUp size={16} />
                </IconButton>
                <IconButton
                  disabled={order === selectedItems.length - 1 || disabled}
                  size="small"
                  onClick={() => handleDown(order, selectedItems)}
                >
                  <ChevronDown size={16} />
                </IconButton>
              </Box>
              <Box display="flex" flexDirection="column">
                <MenuButton>
                  <Button
                    color="secondary"
                    fullWidth
                    size="small"
                    onClick={() => handleOpenDialog(item)}
                    disabled={disabled}
                  >
                    Editar
                  </Button>
                  <Button
                    color="secondary"
                    fullWidth
                    size="small"
                    onClick={() => handleFieldDestroy(item)}
                    disabled={disabled}
                  >
                    Excluir
                  </Button>
                </MenuButton>
              </Box>
            </>
          )}
        </Box>
      )}
    </Box>
  )
}

SelectedItem.propTypes = {
  item: PropTypes.object,
  order: PropTypes.number,
  handleSwitchChange: PropTypes.func,
  handleUp: PropTypes.func,
  handleDown: PropTypes.func,
  handleOpenDialog: PropTypes.func,
  selectedItems: PropTypes.arrayOf(PropTypes.object),
  handleFieldDestroy: PropTypes.func,
  disabled: PropTypes.bool,
}

export default SelectedItem
